import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M8.69,28H7.51V4.78A.6.6,0,0,1,8,4.19a7.68,7.68,0,0,1,5.53.8,9.53,9.53,0,0,1,2.08,1.72,9.32,9.32,0,0,0,1.92,1.62,7.26,7.26,0,0,0,6.16.33.61.61,0,0,1,.54.08.6.6,0,0,1,.24.48V21a.57.57,0,0,1-.38.55c-2.53.91-4.75.91-6.59-.2a8.55,8.55,0,0,1-1.82-1.52A9.47,9.47,0,0,0,13.52,18a7.42,7.42,0,0,0-4.81-.91Z' })
));